import type { IntlShape } from 'react-intl/src/types';
import type { InferType } from 'yup';
import { object, string } from 'yup';

import { EMAIL_REGX } from '@/lib/forms/const';
import { formMessages } from '@/messages/forms';

export type ForgotRepairNumberSchema = InferType<
  ReturnType<typeof forgotRepairNumberSchema>
>;

export const forgotRepairNumberSchema = (
  formatMessage: IntlShape['formatMessage'],
) => {
  const requiredMsg = formatMessage(formMessages.requiredField);

  const schema = object({
    email: string()
      .required(requiredMsg)
      .matches(EMAIL_REGX, formatMessage(formMessages.invalidEmailAddress))
      .default(''),
  });
  return schema;
};
